import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MetaPreviewData } from '../../../../../../../models/meta-template/preview-interfaces/meta-preview-data.interface';
import { MetaCreativeComponent } from '../../../preview-common/meta-creative/meta-creative.component';
import { MetaPreviewCopy } from '../../../preview-common/meta-preview-copy';

/** Marketplace listing details on desktop ("Stranica s pojedinostima o Marketplaceu na stolnom računalu"). */
@Component({
  selector: 'app-meta-marketplace-details-desktop',
  imports: [CommonModule, MetaCreativeComponent],
  templateUrl: './marketplace-details-desktop.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: [
    '../../../preview-common/facebook/marketplace-styles.scss',
    './marketplace-details-desktop.component.scss',
  ]
})
export class MetaMarketplaceDetailsDesktopPreviewComponent {
  @Input() data!: MetaPreviewData;

  readonly pageName = MetaPreviewCopy.FACEBOOK_PAGE_NAME;
  readonly avatar = MetaPreviewCopy.AVATAR;

  get headline(): string {
    return MetaPreviewCopy.headline(this.data);
  }
}